export default "__VITE_ASSET__icB65Kzr__"